export default [
  {
    path: '/antibully/setting',
    name: 'PageBullySetting',
    component: () =>
      import(
        /* webpackChunkName: "antibully" */ '../pages/antibully/PageBullySetting'
      ),
    meta: { modular: 112, title: '设置', info: '防欺凌-设置' }
  },
  {
    path: '/antibully/notifyer',
    name: 'PageBullyNotifyer',
    component: () =>
      import(
        /* webpackChunkName: "antibully" */ '../pages/antibully/PageBullyNotifyer'
      ),
    meta: { modular: 112, title: '通知对象', info: '防欺凌-通知对象' }
  },
  {
    path: '/antibully/resolver',
    name: 'PageBullyResolver',
    component: () =>
      import(
        /* webpackChunkName: "antibully" */ '../pages/antibully/PageBullyResolver'
      ),
    meta: { modular: 112, title: '出警人', info: '防欺凌-出警人' }
  },
  {
    path: '/antibully/device',
    name: 'PageBullyDevice',
    component: () =>
      import(
        /* webpackChunkName: "antibully" */ '../pages/antibully/PageBullyDevice'
      ),
    meta: { modular: 112, title: '防欺凌设备', info: '防欺凌-设备' }
  }
]
